import {getCookie} from "tiny-cookie";

const ZEN_ENGINE = 'zen';
const YANDEX_ENGINE = 'yandex';
const GOOGLE_ENGINE = 'google';
const GOOGLE_NY = 'gny';
const YANDEX_MSK = 'msk';

export default {
    data() {
        return {
            engine: YANDEX_ENGINE
        };
    },
    created() {
        const engine = getCookie('engine');

        if (engine !== undefined) {
            this.engine = engine
        }
    },
    methods: {
        isZen() {
            return this.isZenDatabase
        },
        isYandex() {
            return this.engine === YANDEX_ENGINE
        },
        isGoogle() {
            return this.engine === GOOGLE_ENGINE
        },
        isGoogleNY() {
            return window.report_db.engine === GOOGLE_ENGINE && window.report_db.name === GOOGLE_NY
        },
        isZenEngine(engine) {
            return engine === ZEN_ENGINE;
        },
    },
    computed: {
        isZenDatabase() {
            return this.$store.getters.DATABASE.sename === ZEN_ENGINE;
        },
        isYandexMsk() {
            return window.report_db.name === YANDEX_MSK;
        },
    }
}
